import React from "react";
import { Tabs } from "antd";
import PesticideCustomers from "./PesticideCustomers";
import ChemPesticides from "../../Chemistry/Components/Pesticides/ChemPesticides";
import PesticideCompounds from "./PesticideCompounds";
import "../batchreports.css";
import "./BatchReportPesticide.css";

const pesticidesColumn = [
  {
    title: "Customer",
    dataIndex: "customer_id",
    key: "customer_id",
  },
  {
    title: "WO",
    dataIndex: "workorder_id",
    key: "workorder_id",
  },
  {
    title: "Genista ID",
    dataIndex: "genista_id",
    key: "genista_id",
  },
  {
    title: "Test",
    dataIndex: "test_name",
    key: "test_name",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Submitted By",
    dataIndex: "email",
    key: "email",
  },
  {
    title: <div className="ChemPesticidesTable__Action">Action</div>,
    dataIndex: "action",
    key: "action",
    width: "120px",
    className: "ChemPesticidesTable__Action",
  },
];

const pesticideSampleInfo = [
  {
    label: "Customer ID",
    key: "customer_id",
  },
  {
    label: "Work order",
    key: "workorder_id",
  },
  {
    label: "Genista ID",
    key: "genista_id",
  },
  {
    label: "Sample ID",
    key: "coc_sample_id",
  },
  {
    label: "Sample Type",
    key: "sample_type",
  },
  {
    label: "Test",
    key: "test_name",
  },
  {
    label: "Commodity",
    key: "commodity",
  },
  {
    label: "Received Date",
    key: "received_date",
  },
  {
    label: "Report Date",
    key: "report_date",
  },
];

const items = [
  {
    key: "1",
    label: "Report",
    children: <ChemPesticides
      batchReportView
      tableColumns={pesticidesColumn}
      pesticideSampleInfo={pesticideSampleInfo}
    />,
  },
  {
    key: "2",
    label: "Customers",
    children: <PesticideCustomers />,
  },
  {
    key: "3",
    label: "Compounds",
    children: <PesticideCompounds />,
  },
];
export default function BatchReportPesticide() {
  return (
    <div className="customBatchReports batchReportsSection">
      <Tabs
        destroyInactiveTabPane
        className="CustomAntTab"
        items={items}
      />
    </div>
  );
}
